<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('close')" />
    <div class="modal">
      <div class="title-close">
        <h1 class="modal-title">
          {{ adminText('workflowsAll.are_you_sure_you_want_to_delete_2cba56b', 'Are you sure you want to delete “') }}{{ workflowLabel(eventPassword.password) }}{{ adminText('workflowsAll.password_ca47450', '” password?') }}
        </h1>
        <span class="material-icons" @click="$emit('close')">close</span>
      </div>
      <div class="description">{{ adminText('workflowsAll.users_will_not_be_able_to_use_this_password_a_df6dd59', 'Users will not be able to use this password anymore.') }}</div>
      <div class="buttons">
        <main-button outline color="primary" @click="$emit('close')">{{ adminText('workflowsAll.cancel_77dfd21', 'Cancel') }}</main-button>
        <main-button color="error" @click="$emit('submit', eventPassword.id)">{{ adminText('workflowsAll.delete_f6fdbe4', 'Delete') }}</main-button>
      </div>
    </div>
  </div>
</template>
<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
export default {
  mixins: [WorkflowDisplay],
  name: 'event-password-delete-confirm-modal',
  props: {
    eventPassword: {
      type: Object,
      default: () => ({}),
    },
  },
}
</script>


<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  width: 100%;
  position: relative;
  max-width: 43.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.modal::-webkit-scrollbar {
  display: none;
}
.modal-title {
  color: #0277bd;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 1.25rem;
  font-style: normal;
  font-weight: 600;
  line-height: 120%;
  letter-spacing: -0.0375rem;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
.title-close {
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.material-icons {
  cursor: pointer;
}
.description {
  color: #979797;
  font-family: Source Sans Pro;
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}

.buttons {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
</style>
